module.exports = __webpack_public_path__ + "img/gift+.6da19c6c.svg";